import PropTypes from 'prop-types'
import { useCallback, useContext } from 'react'
import { UsuarioContext } from '../context/usuarioContext'
import { useDropzoneUpload } from '../hooks/useDropzoneUpload'
import ImagenPerfil from '../imagen/ImagenPerfil'
import * as imagenesPerfilService from '../servicios/imagenesPerfilService'

const Upload = ({ idUsuario, accept, idTipo }) => {
  const { setImagenModif } = useContext(UsuarioContext)

  const buildFormData = useCallback(
    (archivo) => {
      const imagen = new FormData()
      imagen.append('nombre', archivo.name)
      imagen.append('idUsuario', idUsuario)
      imagen.append('archivo', archivo)
      imagen.append('idTipo', idTipo)
      return imagen
    },
    [idUsuario, idTipo]
  )

  const { getRootProps, getInputProps } = useDropzoneUpload({
    accept,
    buildFormData,
    uploadFn: imagenesPerfilService.subirArchivo,
    onSuccess: (archivo) => setImagenModif(archivo.lastModified)
  })

  return (
    <>
      <div className="borde-hormiga text-center" {...getRootProps()}>
        <input {...getInputProps()} />
        <div className="row-img-subida contenedor-cont-img-subida-perfil">
          <div className="row">
            <div className="col-6 col-xl-3">
              <div className="row">
                <div className="col-12">
                  <div className="cont-img-subida-perfil">
                    <ImagenPerfil idUsuario={idUsuario} clase="subida-img"></ImagenPerfil>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p>
          {' '}
          Hacé click para cambiar tu foto de perfil. Soltá tu fotografía acá ó arrastrala desde tu
          computadora.
        </p>
      </div>
    </>
  )
}

Upload.propTypes = {
  idUsuario: PropTypes.number.isRequired,
  accept: PropTypes.object.isRequired,
  idTipo: PropTypes.number.isRequired
}

export default Upload
